import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M4.17009 48.6419C4.17009 48.6419 6.70008 43.1419 7.29008 37.4119C7.87008 31.6919 8.6501 20.2419 11.5701 18.2519C11.5701 18.2519 20.1301 17.9219 27.9301 16.9319C37.2001 15.7519 44.4801 18.0319 44.4801 18.0319L46.9101 12.8619C46.9101 12.8619 46.8701 7.3619 44.8701 5.5719C43.6201 4.4619 37.6601 1.1919 24.0301 2.0719C10.4001 2.9519 5.01009 10.6619 3.45009 13.5219C1.90009 16.3919 0.470087 43.3619 4.17009 48.6419Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M46.9201 12.8619C51.8501 12.3119 52.5001 14.2619 53.3101 15.9419C54.7401 18.8919 55.7401 43.3519 52.0401 48.6419C52.0401 48.6419 49.5101 43.1419 48.9201 37.4119C48.3401 31.6919 47.5601 20.2419 44.6401 18.2519L46.9201 12.8619Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M45.77 16.7219C45.77 16.7219 48.5 17.8219 50.05 23.5519C51.6 29.2819 51.61 35.4419 53.56 36.9819"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M46.1602 15.1819C46.1602 15.1819 49.8602 16.2819 51.0302 21.5719C52.2002 26.8619 53.1701 30.6019 53.9501 30.6019"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M48.5 27.512C48.5 27.512 49.86 40.062 53.95 40.942"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M8.97006 22.002C8.97006 22.002 5.44007 29.762 2.32007 31.522"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M8.19009 27.072C8.19009 27.072 5.4601 34.342 2.3501 35.222"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M7.99019 34.9919C7.99019 34.9919 5.82018 41.1019 2.93018 43.1419"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M27.93 16.9418C27.93 16.9418 21.57 2.08181 10.27 6.70181"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M31.6901 16.612C31.6901 16.612 28.9601 1.86198 19.6201 3.18198"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M33.6401 16.392C33.6401 16.392 31.3001 3.40197 25.8501 2.52197"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M38.5102 16.8318C38.5102 16.8318 38.9002 4.72179 32.4702 2.08179"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M40.8402 17.4919C40.8402 17.4919 43.7602 6.26191 37.7202 2.96191"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M25.4601 17.4918C25.4601 17.4918 21.9501 10.4418 14.9401 10.6618C7.93006 10.8818 7.35006 16.8318 3.06006 17.0518"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M20.7901 17.2719C20.7901 17.2719 15.3401 9.12192 2.87012 19.9119"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
    </g>
  )
}
